module.exports = __webpack_public_path__ + "5c28143448cf0a4e4007dad27177ca7b.svg";